import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { createAPIEndpoint, Endpoint } from "../../../Services/stockreport/StockReport";
// import Loader from "../../../Components/Loader";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { Calendar } from "primereact/calendar";

const StockDailyDetailReport = () => {

    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [selectedValue, setSelectedValue] = useState("Pack");
    const [fileType, setFileType] = useState("csv");

    const fileTypes = [
        { label: "CSV", value: "csv" },
        { label: "XLSX", value: "xlsx" },
    ];


    // const handleExportExcel = () => {
    //     const auth = storage.getLocal("user");
    //     setLoadingExcel(true);
    //     const fDate = new Date(fromDate);
    //     const fromDateRange = format(fDate, "dd/MM/yyyy");
    //     const tDate = new Date(toDate);
    //     const toDateRange = format(tDate, "dd/MM/yyyy");
    //     let pck = "N";
    //     let ltr = "N";
    //     if (selectedValue == "Pack") {
    //         pck = "Y"
    //     } else {
    //         ltr = "Y";
    //     }

    //     let uniqueNo = "StockDailyDetailReport";
    //     createAPIEndpoint().get(`${Endpoint.StockDailyDtlRpt}?CompId=${auth.CompId}&userId=${auth.UserId}&startDate=${fromDateRange}&endDate=${toDateRange}&chkpack=${pck}&chkltr=${ltr}`)
    //         .then((val) => {
    //             if (val.data.length > 0) {
    //                 var wb = XLSX.utils.book_new();
    //                 var ws = XLSX.utils.json_to_sheet(val.data);
    //                 XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
    //                 XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
    //             }
    //             else {
    //                 toast.warning(
    //                     "No data found between these dates",
    //                     {
    //                         position: toast.POSITION.TOP_CENTER,
    //                         pauseOnFocusLoss: false,
    //                         closeButton: false,
    //                         autoClose: 2000,
    //                     });
    //             }
    //             setLoadingExcel(false);

    //         }).catch((err) => {

    //             toast.error(
    //                 `${err.response.data}`,
    //                 {
    //                     position: toast.POSITION.TOP_CENTER,
    //                     pauseOnFocusLoss: false,
    //                     closeButton: false,
    //                     autoClose: 2000,
    //                 }

    //             );
    //             setLoadingExcel(false);
    //         });
    // };
    const handleExportExcel = () => {
        let daycount = Math.round(
            (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
        );
        if (daycount > 31) {
            toast.warning("Maximum 31 Days Selection is Allowed !!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (fileType == null) {
            toast.warning(
                "Please select file type",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            return;
        }
        // const auth = storage.getLocal("user");
        setLoadingExcel(true);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");

        let pck = "N";
        let ltr = "N";
        if (selectedValue == "Pack") {
            pck = "Y";
        } else {
            ltr = "Y";
        }

        let uniqueNo = `StockDailyDetail${GetDateFormat()}`;

        createAPIEndpoint().get(`${Endpoint.StockDailyDtlRpt}?CompId=${auth.CompId}&userId=${auth.UserId}&startDate=${fromDateRange}&endDate=${toDateRange}&chkpack=${pck}&chkltr=${ltr}`)
            .then((val) => {
                if (val.data.length > 0) {
                    if (fileType === "xlsx") {
                        var wb = XLSX.utils.book_new();
                        var ws = XLSX.utils.json_to_sheet(val.data);
                        XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                        XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                    } else if (fileType === "csv") {
                        const ws = XLSX.utils.json_to_sheet(val.data);
                        const csv = XLSX.utils.sheet_to_csv(ws);
                        const blob = new Blob([csv], { type: "text/csv" });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `${uniqueNo}.csv`;
                        link.click();
                        window.URL.revokeObjectURL(url);
                    }
                } else {
                    toast.warning(
                        "No data found between these dates",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                }
                setLoadingExcel(false);
            }).catch((err) => {
                toast.error(
                    `${err.response.data}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }
                );
                setLoadingExcel(false);
            });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (checked) {
            setSelectedValue(name);
        } else {
            setSelectedValue(null);
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Stock Daily Detail Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button type="button" className="btn btn-primary" onClick={handleExportExcel} disabled={loadingExcel}>
                                {loadingExcel ? "Loading..." : "Export"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    onChange={(e) => setFromDate(e.value)}
                                    showIcon
                                    value={fromDate}
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                    showMinMaxRange={true}
                                />
                                            
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">To Date</label>

                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy"
                                    showMinMaxRange={true}
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label mb-2">File Type</label>
                                <Dropdown value={fileType}
                                    options={fileTypes}
                                    onChange={(e) => setFileType(e.value)}
                                    optionLabel="label"
                                    placeholder="Select a file type"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 mt-3">
                                <div className="mt-4">
                                    <div className="flex align-items-center d-inline me-3">
                                        <Checkbox inputId="ingredient1" name="Pack" value="Pack" checked={selectedValue === "Pack"}
                                            onChange={handleCheckboxChange} />
                                        <label htmlFor="ingredient1" className="ml-2">Pack</label>
                                    </div>
                                    <div className="flex align-items-center  d-inline">
                                        <Checkbox inputId="ingredient2" name="Ltr" value="Ltr" checked={selectedValue === "Ltr"}
                                            onChange={handleCheckboxChange} />
                                        <label htmlFor="ingredient2" className="ml-2">Ltr.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
                
        </>
    );

};

export default StockDailyDetailReport;